import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const ViewItemCat = ({ show, onClose, categoryId }) => {
  const [categoryData, setCategoryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (show && categoryId) {
      setLoading(true);
      fetch(`${baseURL}/item-categories/${categoryId}`)
        .then(res => res.json())
        .then(data => {
          if (data.data) {
            setCategoryData(data.data);
            setError(null);
          } else {
            setError(data.message || 'Error fetching data');
          }
          setLoading(false);
        })
        .catch(() => {
          setError('Error fetching data');
          setLoading(false);
        });
    }
  }, [show, categoryId]);

  if (!show) return null;

  const onInit = () => {
    // LightGallery initialized
  };

  return (
    <Modal show={show} onHide={onClose} size="md" centered backdrop="static" keyboard={false}> 
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">View Item Category</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          {loading && <p>Loading...</p>}
          {error && <p className="text-danger">{error}</p>}

          {!loading && categoryData && (
            <>
              <div className="mb-2">
                <label className="col-12 text-black fs-7">Category</label>
                <label className="col-12 text-red font-w500 fs-4">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{categoryData.itemcategory_name}
                </label>
              </div>
              <div className="mb-3">
                <label className="col-12 text-black fs-7">Description</label>
                <label className="col-12 text-black font-w400 fs-8">
                  &nbsp;&nbsp;&nbsp;&nbsp;{categoryData.description || 'No description available.'}
                </label>
              </div>

              {/* <div className="row mt-3">
                {categoryData.subcategories.length === 0 && <p>No subcategories available.</p>}

                {categoryData.subcategories.map((subcat) => (
                  <div key={subcat.sno} className="mb-4">
                    <div className="mb-3 d-flex align-items-center">
                      <span className="text-red fs-4 font-w600">{subcat.itemsubcategory_name}</span>
                      <span className="py-0 px-2 rounded-pill fs-6 border border-info text-black badge bg-none ms-2">
                        {subcat.item_count}
                      </span>
                    </div>

                    <div className="row scroll-y mh-350px py-2">
                      {subcat.items.length === 0 && <p className="px-3">No items found in this subcategory.</p>}

                      {subcat.items.map((item) => (
                        <div key={item.sno} className="col-lg-6 mb-3">
                          <div className="card py-0">
                            <div className="card-body px-1 py-1">
                              <div className="d-flex align-items-center justify-content-start gap-2 mb-1">
                                <LightGallery
                                  onInit={onInit}
                                  speed={500}
                                  plugins={[lgThumbnail, lgZoom]}
                                >
                                  <div
                                    data-src={item.item_image}
                                    className="px-1 py-0"
                                  >
                                    <img
                                      src={item.item_image}
                                      alt={item.item_name}
                                      className="cursor-pointer w-60px h-60px"
                                      style={{ objectFit: 'cover' }}
                                    />
                                  </div>
                                </LightGallery>

                                <div>
                                  <label className="fs-5 text-green font-w600">{item.item_name}</label>
                                  <div>
                                    <label className="fs-7 text-info font-w600">
                                      {item.quantity} {item.item_quantity_slug_name || ''}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div> */}
              <div className="row mt-3 scroll-y mh-400px"> {/* Common scroll here */}
  {categoryData.subcategories.length === 0 && <p>No subcategories available.</p>}

  {categoryData.subcategories.map((subcat) => (
    <div key={subcat.sno} className="mb-4 w-100"> {/* w-100 for full row width */}
      <div className="mb-3 d-flex align-items-center">
        <span className="text-red fs-4 font-w600">{subcat.itemsubcategory_name}</span>
        <span className="py-0 px-2 rounded-pill fs-6 border border-info text-black badge bg-none ms-2">
          {subcat.item_count}
        </span>
      </div>

      <div className="row"> {/* No scroll here */}
        {subcat.items.length === 0 && <p className="px-3">No items found in this subcategory.</p>}

        {subcat.items.map((item) => (
          <div key={item.sno} className="col-lg-6 mb-3">
            <div className="card py-0">
              <div className="card-body px-1 py-1">
                <div className="d-flex align-items-center justify-content-start gap-2 mb-1">
                  <LightGallery onInit={onInit} speed={500} plugins={[lgThumbnail, lgZoom]}>
                    <div data-src={item.item_image} className="px-1 py-0">
                      <img
                        src={item.item_image}
                        alt={item.item_name}
                        className="cursor-pointer w-60px h-60px"
                        style={{ objectFit: 'cover' }}
                      />
                    </div>
                  </LightGallery>

                  <div>
                    <label className="fs-5 text-green font-w600">{item.item_name}</label>
                    <div>
                      <label className="fs-7 text-info font-w600">
                        {item.quantity} {item.item_quantity_slug_name || ''}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  ))}
</div>

            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ViewItemCat;
